import React, { useRef } from "react";
import ReportingCards from "../ReportingCards";
import { Row, Col, Space, Carousel, List, Switch, Calendar, Badge, Avatar } from "antd";
import LeaveBalance from "./LeaveBalance";
import DashboardCard from "./dashboardCards";
import { MailOutlined, RightOutlined, LeftOutlined } from "@ant-design/icons";
import HolidaysCarousel from "./holidaysCarousel";
import PostSections from "./PostSections";

const Dashboard = () => {
    const carouselRef = useRef<any>(null);
    const data = [{ type: 'Sick Leave', percentage: 90 }, { type: 'Casual Leave', percentage: 80 }]
    const holidays = [
        {
            name: 'Diwali',
            date: '25 Oct 2024'
        },
        {
            name: 'Holi',
            date: '26 Oct 2024'
        }
    ];

    const cards = [
        {
            title: "Inbox",
            content: (
                <div style={{ textAlign: "center" }}>
                    <Badge count={32} offset={[10, 0]} style={{ backgroundColor: "#9254de" }}>
                        <MailOutlined style={{ fontSize: "36px", color: "#9254de" }} />
                    </Badge>
                    <p>Tasks are waiting for you</p>
                </div>
            ),
            link: "/inbox",
        },
        {
            title: "On Leave Today",
            content: (
                <div>
                    <Avatar.Group max={{ count: 3 }}>
                        <Avatar src="https://via.placeholder.com/150" />
                        <Avatar src="https://via.placeholder.com/150" />
                        <Avatar src="https://via.placeholder.com/150" />
                    </Avatar.Group>
                    <p>Sharma Ravi, Sharma Ravi, Sharma Ravi</p>
                </div>
            ),
            link: "/on-leave",
        },
    ];

    return <Row gutter={8}>
        <Col span={20}>
            <Space direction="vertical">
                <Row gutter={8}>
                    <Col span={8}>
                        <HolidaysCarousel holidays={holidays} />
                    </Col>
                    {cards.map(e => <Col span={8}>
                        <DashboardCard card={e} />
                    </Col>)}
                </Row>
                <Row gutter={8}>
                    <Col span={24}>
                        <PostSections />
                    </Col>
                </Row>
            </Space>
        </Col>
        <Col span={4}>
            <Space direction="vertical">
                <LeaveBalance data={data} />
                <ReportingCards />
            </Space>
        </Col>
    </Row>
}

export default Dashboard;